import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader, RequestContentType } from 'utils/Helpers'

const DefaultEmbedAPI = Marty.createStateSource({
  id: 'DefaultEmbedAPI',
  type: 'http',
  baseUrl: ResourcesConstants.WIDGET_CACHE_API,

  fetchDefaultEmbed() {
    return this.get({
      url: `/embeds/_default`,
      headers: getAuthorizationHeader()
    })
  },

  patchDefaultEmbed(operations) {
    return this.patch({
      url: '/embeds/_default/configuration',
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(operations)
    })
  },

  refreshDefaultEmbed() {
    return this.put({
      url: '/embeds/_default/refresh',
      headers: getAuthorizationHeader()
    })
  }
})

export default DefaultEmbedAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/DefaultEmbedAPI.js